var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m237.768 34.232c104.844 0 192.672 72.763 215.795 170.54h34.459c3.126 0 5.803 1.681 7.161 4.497s1.007 5.958-.941 8.404l-68.88 86.555c-1.56 1.96-3.716 3-6.221 3s-4.661-1.04-6.221-3l-68.88-86.555c-1.947-2.446-2.299-5.588-.941-8.404s4.035-4.497 7.162-4.497h34.438c-21.177-60.76-78.951-104.364-146.931-104.364-85.931 0-155.591 69.66-155.591 155.592s69.661 155.591 155.591 155.591c38.954 0 74.565-14.315 101.858-37.971 4.768-4.133 11.883-3.879 16.345.583l29.883 29.883c2.422 2.421 3.607 5.404 3.51 8.827s-1.45 6.333-4.005 8.613c-39.204 34.981-90.915 56.242-147.591 56.242-122.479 0-221.767-99.289-221.767-221.768s99.288-221.768 221.767-221.768z",
    fill: "#ff3838",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.2a985d1a5bcb03ee1c3329f76e45cf82.svg";
export { ForwardRef as ReactComponent };